// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__3iWGV","total":"MasterSaleDetails_total__L-e8R","edit":"MasterSaleDetails_edit__s-qoC","cancel":"MasterSaleDetails_cancel__4EF+W"};